exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports
exports.i(require("-!./../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../node_modules/postcss-loader/index.js!./_base.css"), undefined);

// module
exports.push([module.id, "._3Ue4q58Ya6q2FCTVkZKllk {\n}\n", ""]);

// exports
exports.locals = {
	"typeRef": "_3Ue4q58Ya6q2FCTVkZKllk " + require("-!./../../node_modules/css-loader/index.js?modules&importLoaders=1!./../../node_modules/postcss-loader/index.js!./_base.css").locals["typeLink"] + ""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=1!./~/postcss-loader!./src/components/TypeRefView.css
 ** module id = 16
 ** module chunks = 0
 **/